var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsDialog',{ref:"WsDialog",attrs:{"title":"覆核","escMetaClose":true},scopedSlots:_vm._u([{key:"content",fn:function(){return [_vm._v(" afasdf ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }